<div class="container ps-0">
  <div class="row">
    <div *ngFor="let item of data" [class]="gridSize" class="mb-4">
      <div class="card execution-card d-flex flex-row">
        <div class="icon-container">
          <img src="assets/images/virtusa-icons/{{item.name}}.svg" alt="add">
        </div>
        <div class="content flex-column">
          <span class="accello-general-text11 d-flex justify-content-start">{{ item.display_name }}</span>
          <span class="accello-general-text7 d-flex justify-content-start">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
